import { useState, useEffect } from 'react';
import { useHover, useFocusWithin, useFocusManager } from 'react-aria';
export const useInitialPromptsAccessibility = ({
  shouldTrapFocus,
  onHoverChange
}) => {
  const [shouldContainFocus, setShouldContainFocus] = useState(shouldTrapFocus);
  const focusManager = useFocusManager();
  useEffect(() => {
    setShouldContainFocus(shouldTrapFocus);
  }, [shouldTrapFocus]);
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onHoverChange(false);
        setShouldContainFocus(false);
        focusManager.focusLast();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onHoverChange, focusManager]);
  const {
    hoverProps
  } = useHover({
    onHoverStart: () => onHoverChange(true),
    onHoverEnd: () => onHoverChange(false)
  });
  const {
    focusWithinProps
  } = useFocusWithin({
    onFocusWithinChange: isFocusWithin => {
      if (!isFocusWithin) {
        const activeElement = document.activeElement;
        if (activeElement instanceof HTMLElement) {
          activeElement.blur();
        }
      }
      onHoverChange(isFocusWithin);
      setShouldContainFocus(shouldTrapFocus && isFocusWithin);
    }
  });
  const interactionProps = Object.assign({}, hoverProps, focusWithinProps);
  return {
    interactionProps,
    shouldContainFocus
  };
};